export const isWebpEnabled =
    typeof process !== 'undefined' &&
    import.meta.env.MODE !== 'development' &&
    import.meta.env.MODE !== 'test'
